import fr from "./fr"
import uk from "./uk"
import nl from "./nl"
import yoonlyFr from "./yoonly-fr"
import yoonlyNl from "./yoonly-nl"

export default {
    nl, uk, fr, 'yoonly-fr': yoonlyFr, 'yoonly-nl': yoonlyNl
}